import ReactGA from "react-ga4";
import * as events from "./events";
import { category, action } from "./constants";
import { useGA4 } from "./constants";

const handleGA = (event, label) => {
  if (useGA4) {
    switch (event) {
      case events.PAGE_VIEW:
        ReactGA.send({ hitType: "pageview", page: label });
        break;
      case events.SEARCH_THE_LIBRARY:
        ReactGA.event({
          category: category.input,
          action: action.searchTheLibrary,
          label: label,
        });
        break;
      case events.VIEW_EVENT:
        ReactGA.event({
          category: category.view,
          action: action.viewEvent,
          label: label,
        });
        break;
      case events.VIEW_HELP:
        ReactGA.event({
          category: category.help,
          action: action.viewHelp,
          label: label,
        });
        break;
      case events.DOWNLOAD_FILE:
        ReactGA.event({
          category: category.download,
          action: action.downloadFile,
          label: label,
        });
        break;
      case events.DOWNLOAD_LINK:
        ReactGA.event({
          category: category.download,
          action: action.downloadLink,
          label: label,
        });
        break;
      case events.DOWNLOAD_DATA_DICTIONARY:
        ReactGA.event({
          category: category.download,
          action: action.downloadDataDictionary,
          label: label,
        });
        break;
      case events.NAVIGATE_TO_EXTERNAL_RESOURCE:
        ReactGA.event({
          category: category.navigation,
          action: action.navigateToExternalResource,
          label: label,
        });
        break;
      default:
        ReactGA.event({
          category: category.error,
          action: action.error,
        });
    }
  }
};

export const gaEvents = events;
export default handleGA;
